module.exports = __webpack_public_path__ + "img/step11_gray.988a42fd.png";